import React from "react";

import { Draggable } from "react-beautiful-dnd";

import CategorizedField, { CategoryFieldType } from "../../type/CategorizedField";
import SchemaMap from "../../type/SchemaMap";
import PaletteFieldName from "../PaletteFieldName";

import styles from "./PaletteCategoryList.module.scss";

interface Props {
  category: CategorizedField;
  locked?: boolean;
  onDoubleClick?: () => void;
  schemaMap: SchemaMap;
  startIndex?: number;
}

const PaletteCategoryList: React.FC<Props> = ({
  category,
  locked,
  onDoubleClick,
  schemaMap,
  startIndex = 0,
}) => {
  return category.fields?.length > 0 ? (
    <div className={styles.container}>
      <div className={styles.name}>{category.name}</div>

      <div className={styles.list}>
        {category.fields.map((categoryField: CategoryFieldType, index: number) => (
          <Draggable
            draggableId={categoryField.field}
            index={index + startIndex}
            isDragDisabled={categoryField.disabled}
            key={categoryField.field}
          >
            {({ draggableProps, dragHandleProps, innerRef }, { draggingOver, isDragging }) => (
              <>
                <div
                  {...draggableProps}
                  ref={innerRef}
                  style={{
                    ...draggableProps.style,
                    transform: isDragging ? draggableProps.style?.transform : "translate(0px, 0px)",
                    transitionDuration: "0.001s",
                  }}
                >
                  <PaletteFieldName
                    categoryField={categoryField}
                    dragging={isDragging}
                    draggingOver={draggingOver}
                    dragHandleProps={dragHandleProps}
                    locked={locked}
                    onDoubleClick={onDoubleClick}
                    schemaMap={schemaMap}
                  />
                </div>

                {isDragging && !categoryField.disabled && locked && (
                  <PaletteFieldName categoryField={categoryField} locked schemaMap={schemaMap} />
                )}
              </>
            )}
          </Draggable>
        ))}
      </div>
    </div>
  ) : null;
};

export default PaletteCategoryList;
